import React from 'react';

interface NavigationSectionProps {
  title: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
}

const NavigationSection: React.FC<NavigationSectionProps> = ({ title, icon, children }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '20px'
    }}>
      {/* Section Header - Tabby Style */}
      <div style={{
        marginTop: '20px',
        marginBottom: '8px'
      }}>
        <span style={{
          color: '#9CA3AF', // Tabby muted text color
          fontWeight: 500,
          fontSize: '11px',
          lineHeight: '16px',
          letterSpacing: '0.5px',
          textTransform: 'uppercase',
          fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
        }}>
          {title}
        </span>
      </div>
      
      {/* Section Items */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '2px'
      }}>
        {children}
      </div>
    </div>
  );
};

export default NavigationSection;
